var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { SelectableTable as SelectableTableComponent, SelectableTableHeader, SelectableTableRow, SelectableTableCell, } from './SelectableTable.styles';
import { ArrowDropDown, ArrowDropUp, } from '@mui/icons-material';
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection || (SortDirection = {}));
var SelectableTable = function (props) {
    var rows = props.rows, onRowSelect = props.onRowSelect, headers = props.headers, initiallySelectedRow = props.initiallySelectedRow;
    var initialRows = function () {
        return rows;
    };
    var _a = useState(initialRows), rowSet = _a[0], setRowSet = _a[1];
    var _b = useState(0), sortColumn = _b[0], setSortColumn = _b[1];
    var _c = useState(SortDirection.DESC), sortDirection = _c[0], setSortDirection = _c[1];
    var _d = useState(initiallySelectedRow || null), selectedRow = _d[0], setSelectedRow = _d[1];
    useEffect(function () {
        setRowSet(doSort(sortColumn, SortDirection.DESC, rows));
    }, [rows]);
    var doSort = function (col, direction, rowsToSort) {
        return __spreadArray([], rowsToSort, true).sort(function (a, b) {
            if (a[col] === b[col]) {
                return 0;
            }
            if (direction === SortDirection.ASC) {
                // eslint-disable-next-line
                // @ts-ignore
                return a[col] < b[col] ? -1 : 1;
            }
            // eslint-disable-next-line
            // @ts-ignore
            return a[col] < b[col] ? 1 : -1;
        });
    };
    var sortRows = function (col, direction) {
        setRowSet(doSort(col, direction, rowSet));
    };
    var renderCell = function (cell, idx, key, row) {
        return (React.createElement(SelectableTableCell, { selected: key === selectedRow, key: "".concat(key, "-").concat(idx), onClick: function () {
                var value = key === selectedRow ? null : key;
                setSelectedRow(value);
                onRowSelect(row, value);
            } }, cell));
    };
    var renderRow = function (row) {
        var key = "row-".concat(row.join('-'));
        return (React.createElement(SelectableTableRow, { key: key }, row.map(function (cell, cidx) {
            return renderCell(cell, cidx, key, row);
        })));
    };
    var renderHeaders = function () {
        return headers.map(function (header, idx) {
            return (React.createElement(SelectableTableHeader, { key: "selectable-table-header-header-".concat(header), onClick: function () {
                    var currSortDirection = sortDirection;
                    if (idx === sortColumn) {
                        currSortDirection =
                            currSortDirection === SortDirection.ASC
                                ? SortDirection.DESC
                                : SortDirection.ASC;
                    }
                    else {
                        setSortColumn(idx);
                        currSortDirection = SortDirection.DESC;
                    }
                    setSortDirection(currSortDirection);
                    sortRows(idx, currSortDirection);
                } },
                header,
                sortDirection === SortDirection.DESC && sortColumn === idx ? (React.createElement(ArrowDropUp, null)) : (React.createElement(ArrowDropDown, null))));
        });
    };
    return (React.createElement(SelectableTableComponent, null,
        React.createElement("thead", null,
            React.createElement("tr", null, renderHeaders())),
        React.createElement("tbody", null, rowSet.map(function (row) {
            return renderRow(row);
        }))));
};
export default SelectableTable;
